/**
 * Blog Posts Grid — Load More (Home)
 * Carrega mais posts via AJAX ao clicar no botão.
 */

export function initBlogPostsGridLoadMore() {
	const btn = document.querySelector( '.blog-posts-grid__btn' );
	if ( ! btn ) return;

	const grid = document.querySelector( '.blog-posts-grid__grid' );
	if ( ! grid ) return;

	const excludeId = parseInt( btn.dataset.exclude || 0, 10 );

	// IDs já na tela — o backend usa post__not_in em vez de offset (ver
	// blog-related-load-more.js para o motivo).
	const collectExcluded = () =>
		Array.from(
			new Set(
				Array.from( document.querySelectorAll( '[data-post-id]' ) )
					.map( ( el ) => parseInt( el.dataset.postId, 10 ) )
					.filter( Boolean )
			)
		).join( ',' );

	btn.addEventListener( 'click', async ( e ) => {
		e.preventDefault();

		btn.textContent = 'Carregando...';
		btn.style.pointerEvents = 'none';
		btn.style.opacity = '0.6';

		try {
			const formData = new FormData();
			formData.append( 'action', 'rb_load_more_posts_grid' );
			formData.append( 'exclude_id', excludeId );
			formData.append( 'excluded_ids', collectExcluded() );
			formData.append( 'nonce', rbAjax.nonce );

			const response = await fetch( rbAjax.url, {
				method: 'POST',
				body: formData,
			} );

			const data = await response.json();

			if ( data.success && data.data.html ) {
				grid.insertAdjacentHTML( 'beforeend', data.data.html );

				if ( ! data.data.has_more ) {
					btn.textContent = 'Não há mais conteúdos';
					btn.style.pointerEvents = 'none';
					btn.style.opacity = '0.4';
				} else {
					btn.textContent = 'Carregar mais conteúdos';
					btn.style.pointerEvents = '';
					btn.style.opacity = '';
				}
			} else {
				btn.textContent = 'Não há mais conteúdos';
				btn.style.pointerEvents = 'none';
				btn.style.opacity = '0.4';
			}
		} catch ( err ) {
			btn.textContent = 'Erro ao carregar';
			btn.style.pointerEvents = 'none';
			btn.style.opacity = '0.4';
		}
	} );
}
